const NATIVE_MARKETING_CHROME_PREFIXES = ["/sign-in", "/sign-up", "/join"] as const;

/**
 * Routes where the installed app should drop the marketing site header,
 * footer, and editorial auth panels. Subpaths such as Clerk's
 * `/sign-in/factor-one` stay included.
 */
export function hidesNativeMarketingChrome(pathname: string): boolean {
  return NATIVE_MARKETING_CHROME_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
